module.exports = __webpack_public_path__ + "img/robot.f1f96123.png";